import {
    Accordion,
    createAccordion,
} from '@vfde-brix/ws10/accordion';
import { useAppDispatch } from '../app/store';
import { toggleAccordion } from '../features/app/slice';

/**
 * We have to mount the accordion once even if we don't use it in code, so the JS gets packed by webpack
 */
export const mountAccordion = (
    containerId: string): void | Accordion => {
    const container = document.getElementById(containerId);

    container && createAccordion(container, {
        onToggle: itemProperties => {
            const dispatch = useAppDispatch();
            dispatch(toggleAccordion(itemProperties));
        },
    });
};
